import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Community from './pages/Community';
import Thread from './pages/Thread';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Enroll from './pages/Enroll';
import PaymentResult from './pages/PaymentResult';
import Profile from './pages/Profile';
import AuthCallback from './pages/AuthCallback';
import Admin from './pages/Admin';
import LiveBanner from './components/LiveBanner';
import SignupNudge from './components/SignupNudge';
import useBodyPointerGuard from './hooks/useBodyPointerGuard';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';
import { trackView } from './lib/api';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Tracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin') || pathname.startsWith('/auth')) return;
    let vid = localStorage.getItem('bzpm_vid');
    if (!vid) {
      vid = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem('bzpm_vid', vid);
    }
    if (!localStorage.getItem('bzpm_first')) localStorage.setItem('bzpm_first', String(Date.now()));
    localStorage.setItem('bzpm_vc', String((parseInt(localStorage.getItem('bzpm_vc') || '0', 10)) + 1));
    trackView({ path: pathname, visitor_id: vid, ref: document.referrer || '' }).catch(() => {});
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest && e.target.closest('[data-cta]');
      if (!el) return;
      const label = el.getAttribute('data-cta');
      const vid = localStorage.getItem('bzpm_vid') || 'anon';
      trackView({ path: window.location.pathname, visitor_id: vid, type: 'click', label }).catch(() => {});
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
  return null;
}

function PointerGuard() {
  useBodyPointerGuard();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Tracker />
          <PointerGuard />
          <LiveBanner />
          <Navbar />
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/community" element={<Community />} />
            <Route path="/community/:id" element={<Thread />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/enroll" element={<Enroll />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          </ErrorBoundary>
          <Footer />
          <SignupNudge />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
